import { CONSTANTS_ID } from '../../constants/constants';
import { CREATE_SURFACE_KIND } from './constants';
import type { CreateSession, CreateSurfaceKind } from './types';

function isCreateRoute(pathname: string): boolean {
    return pathname.split('/').includes(CONSTANTS_ID.createId);
}

/** Breadcrumbs and drawer links disagree on a trailing slash; treat them as the same list route. */
function normalizePathname(pathname: string): string {
    if (!pathname || pathname === '/') {
        return pathname || '/';
    }
    return pathname.replace(/\/+$/, '') || '/';
}

export function getCreateSurfaceKind(session: CreateSession, pathname: string): CreateSurfaceKind {
    const currentPath = normalizePathname(pathname);
    const listPath = normalizePathname(session.listPathname);

    if (currentPath === listPath) {
        return CREATE_SURFACE_KIND.modalOverList;
    }

    if (currentPath.startsWith(`${listPath}/`) && isCreateRoute(currentPath)) {
        return CREATE_SURFACE_KIND.createScreen;
    }

    return CREATE_SURFACE_KIND.none;
}
